module.exports = __webpack_public_path__ + "static/media/IB_logo.4e02d243.png";